import { ColDef } from 'ag-grid-community';
import { Badge } from 'antd';
import moment from 'moment';
import { Link } from 'react-router-dom';

import { OneOfAsyncFilterDataGrid } from 'app/common/ui/data-grid/filters';
import { RangeDateFilterDataGrid } from 'app/common/ui/data-grid/filters/range-date';
import { appRoute } from 'app/railways/router/routes';

import { TTrip } from '../../core/trips';
import { getRoutesRequest } from '../../requests/get-routes.request';
import { getTrainTypesRequest } from '../../requests/get-train-types.request';
import { END_TIME_FILTER_NAME, START_TIME_FILTER_NAME } from './local-params';

export const cols: ColDef[] = [
  {
    field: 'id',
    // type: 'rightAligned',
    headerName: 'ID',
    minWidth: 50,
    headerCheckboxSelection: true,
    checkboxSelection: true,
    sortable: true,
    comparator: () => 0,
    cellRenderer: ({ value }: { value: number }) => {
      const routePath = appRoute.TRIP.buildPath({ id: value });

      return <Link to={routePath}>{value}</Link>;
    },
  },
  {
    field: 'blocked',
    headerName: 'Статус',
    sortable: true,
    comparator: () => 0,
    cellRenderer: ({ value }: { value: boolean }) => {
      switch (value) {
        case true:
          return (
            <Badge
              status="error"
              text="Заблокирован"
              style={{ whiteSpace: 'nowrap' }}
            />
          );
        case false:
          return (
            <Badge
              status="success"
              text="Активен"
              style={{ whiteSpace: 'nowrap' }}
            />
          );

        default:
          return <span>???</span>;
      }
    },
  },
  {
    field: 'route.number',
    headerName: 'Номер маршрута',
    sortable: true,
    colId: 'routeNumber',
    comparator: () => 0,
  },
  {
    field: 'route.nameRu',
    headerName: 'Маршрут',
    sortable: true,
    colId: 'route',
    filter: OneOfAsyncFilterDataGrid({
      filterName: 'routeId',
      asyncData: {
        request: getRoutesRequest,
        prepareData: (data: { content: { id: number; nameRu: string }[] }) =>
          data.content.map((item) => ({ value: item.id, label: item.nameRu })),
      },
    }),
    comparator: () => 0,
  },
  {
    field: 'trainType.nameRu',
    headerName: 'Тип состава',
    sortable: true,
    colId: 'trainType',
    filter: OneOfAsyncFilterDataGrid({
      filterName: 'trainTypeId',
      asyncData: {
        request: getTrainTypesRequest,
        prepareData: (data: { content: { id: number; nameRu: string }[] }) =>
          data.content.map((item) => ({ value: item.id, label: item.nameRu })),
      },
    }),
    comparator: () => 0,
  },
  {
    field: START_TIME_FILTER_NAME,
    headerName: 'Дата отправления',
    valueFormatter: ({ value }) => new Date(value).toLocaleString(),
    filter: RangeDateFilterDataGrid({ filterName: START_TIME_FILTER_NAME }),
    sortable: true,
    comparator: () => 0,
  },
  {
    field: END_TIME_FILTER_NAME,
    headerName: 'Дата прибытия',
    valueFormatter: ({ value }) => new Date(value).toLocaleString(),
    filter: RangeDateFilterDataGrid({ filterName: END_TIME_FILTER_NAME }),
    sortable: true,
    comparator: () => 0,
  },
  {
    field: 'seatCount',
    headerName: 'Всего мест',
    sortable: true,
    comparator: () => 0,
  },
  {
    field: 'soldSeatCount',
    headerName: 'Продано мест',
  },
  {
    field: 'refundStopDelay',
    headerName: 'Закрытие возврата',
    valueFormatter: ({ value, data }) => {
      if (!data) return '';

      const startRouteDate = moment(data.startTime);

      const final = startRouteDate.add(value, 'minutes');
      const result = final.toDate().toLocaleString();

      return result;
    },
  },
  {
    field: 'salesStopDelay',
    headerName: 'Закрытие продаж',
    sortable: true,
    comparator: () => 0,
    valueFormatter: ({ value, data }) => {
      if (!data) return '';

      const startRouteDate = moment(data.startTime);
      const final = startRouteDate.add(value, 'minutes');
      const result = final.toDate().toLocaleString();

      return result;
    },
  },
  {
    field: 'details',
    // type: 'rightAligned',
    headerName: 'Подробнее',
    // headerCheckboxSelection: true,
    cellRenderer: ({ data }: { data?: TTrip }) => {
      if (!data) return null;
      const routePath = appRoute.TRIP.buildPath({ id: data.id });

      return <Link to={routePath}>Открыть</Link>;
    },
  },
];
